export const Anchor = {
  News: 'news',
  Attachments: 'attachments',
} as const;

export type Anchor = (typeof Anchor)[keyof typeof Anchor];
